<template>
    <v-layout>
        <v-flex class="forum-non-member-message px-1 py-2" v-if="$route.path.includes('/forum')"
                data-qe-id="non-member_forum_message"
                v-html="communityCommonConstant.post.FORUM_NONMEMBER_MESSAGE">
        </v-flex>
        <v-flex class="region-non-member-message px-1 py-2"
                data-qe-id="non-member_region_message"
                v-if="$route.path.includes('/region')">
            {{communityCommonConstant.ActivityFeed.ALL_COMMUNITY_NON_MEMBER_MESSAGE}} region.
        </v-flex>      
        <v-flex class="panelBlock group-non-member-message"
                data-qe-id="non-member_invisible_group_message"
                v-if="$route.path.toLowerCase().includes('/group') && !isVisible">
            <v-flex>
                <span v-html="communityCommonConstant.group.GROUP_NONMEMBER_MESSAGE_PRE"></span>
                Click <strong><a class="group-non-member-message__directoryLink"
                                 data-qe-id="non-member_show-group-directory_link"
                                 @click="showGroupDirectory">here</a></strong>
                {{communityCommonConstant.group.GROUP_NONMEMBER_MESSAGE_POST}}
            </v-flex>
            <div class="group-non-member-message__request mt-4">
                <h6>{{communityCommonConstant.group.REQUEST_GROUP}}</h6>
                <p>{{communityCommonConstant.group.REQUEST_GROUP_INFO}}</p>
            </div>
            <group-request class="group-non-member-message__form"></group-request>
        </v-flex>
         <v-flex class="region-non-member-message px-1 py-2"
                 data-qe-id="non-member_visible_group_message"
                 v-if="$route.path.toLowerCase().includes('/group') && isVisible">
            {{communityCommonConstant.ActivityFeed.ALL_COMMUNITY_NON_MEMBER_MESSAGE}} group.
        </v-flex>
        <v-flex class="px-1 py-2"
                data-qe-id="non-member_champion_message"
                v-if="$route.path.includes(`/${routerNames.CHAMPION}`)">
          {{communityCommonConstant.champion.NO_COMMUNITY_MESSAGE}}
        </v-flex>
      </v-layout>
</template>

<script>
    import { communityCommonConstant } from "../communityCommon.constant";
    import GroupRequest from "../../GroupPage/GroupRequest";
    import { storeGetters } from '@/store/storeGetters.constant';
    import { mapGetters } from 'vuex';
    import { routerNames } from "@/components/appCommon.constants";

    export default {
        name: "NonMemberMessage",
        components: {
            GroupRequest,
        },
        data() {
            return {
              communityCommonConstant,
              routerNames,
            };
        },
        methods: {
            showGroupDirectory() {
                this.$router.push({
                    path: '/communityDirectoryPage',
                    query: {
                        filters: '',
                        navigatedFromId: '',
                        communitySearchText: '',
                        communityFilters: JSON.stringify({
                            "CommunityType": [{
                                "label": "Group",
                                "filterKey": "CommunityType",
                                "filterValue": "Group",
                                "isTypeAhead": false,
                                "subFilters": [],
                                "ribbonGroupName": "Community Type",
                            }],
                            "CommunityFocus": [],
                            "EligibilityRequirements": [],
                        }),
                    },
                });
            },
        },
        computed: {
            ...mapGetters({
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
            }),
            isVisible() {
                return this.usersCommunitiesList && this.usersCommunitiesList.some(o => o.communityType.toLowerCase() === this.$route.name);
            },
        },
    };
</script>

<style lang="scss">
    @import "../../../common/styles/_colors.scss";
    @import "../../../common/styles/_responsive.scss";

    .forum-non-member-message {
        font-weight: bold;
    }

    .group-non-member-message {
        background: $white;
        padding: 20px;
        letter-spacing: 0.26px;
        line-height: 20px;

        h3 {
            text-align: center;
            color: $ypo-blue;
            font-family: "Raleway", sans-serif;
            font-size: 22px;
            font-weight: 500;
            line-height: 26px;
            margin-bottom: 30px;
        }

        p {
            margin-bottom: 20px;
        }

        &__directoryLink {
            color: #44779F;
        }

        &__request {
            margin: 0 -20px;

            h6 {
                font-size: 16px;
                letter-spacing: 0.3px;
                line-height: 20px;
                font-weight: 400;
                border-bottom: 1px solid $ypo-medium-gray;
                padding: 0 0 25px 20px;
                margin-bottom: 15px;
            }

            p {
                margin: 0 20px;
                border-bottom: 1px solid $ypo-medium-gray;
                padding-bottom: 15px;
            }
        }

        &__form {
            h6 {
                font-weight: 400;
                margin-bottom: 15px;
                color: $ypo-gray-text;
                font-size: 14px;
                letter-spacing: 0.26px;
                line-height: 20px;
                margin-top: 10px;
            }

            p {
                font-size: 14px;
                margin-bottom: 0px;
                padding-left: 30px;
            }

            .v-radio {
                margin-bottom: 15px !important;
                align-items: flex-start;

                .v-icon {
                    font-size: 20px;
                    margin-left: 2px;
                }
            }

            em {
                font-style: normal;
                color: $ypo-cta;
                font-weight: 400;

                i {
                    margin-right: 5px;
                    position: absolute;
                    left: 2px;
                    top: 5px;
                }
            }

            .terms {
                strong {
                    color: $ypo-cta;
                    font-size: 14px;
                    font-weight: 500;
                    letter-spacing: 0.26px;
                    line-height: 20px;
                    display: block;
                    margin-bottom: 10px;
                }

                .v-label {
                    font-size: 14px;
                    color: $ypo-gray-text !important;
                    font-weight: 400;
                }
            }
        }

        .groupRequestRadio {
            color: $ypo-gray-text;
            font-size: 12px;
            font-weight: initial;
        }

        .button-group {
            border-top: 1px solid $ypo-medium-gray;
            margin: 0 -28px -20px -30px;
            padding: 7px 15px 0 0;
            text-align: right;
        }

        .description {
            strong {
                font-weight: 400;
            }

            textarea {
                border: 1px solid $ypo-medium-gray;
                border-radius: 4px;
                height: 60px;
            }

            .error--text {
                textarea {
                    border-color: $ypo-error-red;
                }
            }

            .v-input__slot {
                &:before {
                    display: none;
                }
            }
        }

        .v-alert {
            text-align: left;
            padding: 5px 5px;
            margin: 5px 0 5px 15px;
        }
    }
</style>

